import { UserFullInfo } from '@entities/User/types/user.fullInfo'

export const isUserFullSetup = (userData: Partial<UserFullInfo>): boolean => {
	return !!(
		userData.sex &&
		userData.height &&
		userData.weight &&
		userData.birthday &&
		userData.firstName &&
		userData.lastName
	)
}
